var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.1 471L370.1 337C399.1 301.5 415.1 256.8 415.1 208C415.1 93.1 321.97 0 207.1 0C92.2302 0 0 93.13 0 208C0 322.87 93.1202 416 207.1 416C255.89 416 300.65 399.09 336.1 370.96L470.1 504.96C475.7 509.7 481.9 512 488 512C494.1 512 500.28 509.656 504.97 504.969C514.3 495.6 514.3 480.4 504.1 471ZM48.0002 208C48.0002 119.78 119.78 48 208 48C296.22 48 368 119.78 368 208C368 296.22 296.22 368 208 368C119.78 368 48.0002 296.2 48.0002 208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e50707834344e0ace71844efb20c5c1e.svg";
export { ForwardRef as ReactComponent };